import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AgentLegalForm from "../../../enum/AgentLegalForm.enum";
import { FieldColumn, FieldRow, Section, SectionTitle } from "../styles";
import { AgentFormState } from "../../../types/agentTypes";

type BaseDataSectionProps = {
  formData: AgentFormState;
  isCreate: boolean;
  onFormatChange: (e: SelectChangeEvent) => void;
  onTechnicalChange: (checked: boolean) => void;
};

const BaseDataSection = ({
  formData,
  isCreate,
  onFormatChange,
  onTechnicalChange,
}: BaseDataSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t("createAgent.baseData.title")}</SectionTitle>

      {!!String(formData.pager ?? "").trim() && (
        <FieldRow>
          <FieldColumn>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mb: 0.5 }}
            >
              {t("myData.fields.pager")}
            </Typography>
            <Typography variant="body1">
              {String(formData.pager ?? "")}
            </Typography>
          </FieldColumn>
        </FieldRow>
      )}

      <FieldRow style={{ alignItems: "flex-start" }}>
        <FieldColumn>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!formData.is_technical}
                onChange={(e) => onTechnicalChange(e.target.checked)}
                disabled={!isCreate}
              />
            }
            label={t("createAgent.baseData.technical")}
          />
        </FieldColumn>
      </FieldRow>

      <FieldRow>
        <FieldColumn>
          <FormControl fullWidth size="small">
            <InputLabel id="format-label">
              {t("createAgent.baseData.legalForm")}
            </InputLabel>

            <Select
              name="format"
              label={t("createAgent.baseData.legalForm")}
              labelId="format-label"
              value={formData.format ?? ""}
              onChange={onFormatChange}
              disabled={!isCreate}
              required
              fullWidth
            >
              <MenuItem value={AgentLegalForm.PERSON}>
                {t("createAgent.baseData.person")}
              </MenuItem>

              <MenuItem value={AgentLegalForm.ENTREPRENEUR}>
                {t("createAgent.baseData.entrepreneur")}
              </MenuItem>

              <MenuItem value={AgentLegalForm.COMPANY}>
                {t("createAgent.baseData.company")}
              </MenuItem>
            </Select>
          </FormControl>
        </FieldColumn>
      </FieldRow>
    </Section>
  );
};

export default BaseDataSection;
